// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17b9W","label":"styles_label__1Gxf_"};